import { Outlet } from 'react-router-dom';

interface OutletLayoutProps {
  Component: React.ComponentType<{ children: React.ReactNode }>;
}

// Simple helper to wrap the given component around an outlet for a layout
const OutletLayout = ({ Component }: OutletLayoutProps) => (
  <Component>
    <Outlet />
  </Component>
);

export default OutletLayout;
